import { Comment } from "@/types/comment";

export class Issue {

    id: string;
    folio: number;
    title: string;
    description: string;
    statusText: string;
    statusId: number;
    typeId: number;
    typeText: string
    dateText: string
    createdAt: string
    updatedAt: string
    attachedFiles: Document[];
    comments: Comment[]

    constructor(id: string, folio: number, title: string, description: string, statusText: string, statusId: number, typeId: number, typeText: string, dateText: string, createdAt: string, updatedAt: string, attachedFiles: Document[], comments: Comment[]) {
        this.id = id;
        this.folio = folio;
        this.title = title;
        this.description = description;
        this.statusId = statusId;
        this.statusText = statusText;
        this.typeId = typeId;
        this.typeText = typeText;
        this.dateText = dateText;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.attachedFiles = attachedFiles;
        this.comments = comments;
    }

    className() {

        let className = 'issues-card';

        if (this.statusId == 100) {
            className += ' issue-pending';
        }

        if (this.statusId == 200) {
            className += ' issue-in-course';
        }

        if (this.statusId == 300) {
            className += ' issue-finished';
        }

        return className;
    }
}

export class NewIssue {

    titulo: string;
    descripcion: string;
    prioridad: string;
    contrato: string;
    tipo: number;
    fecha: any;
    fechaVencimiento: any;
    adjuntos: any[]
    
    constructor(titulo: string, descripcion: string, prioridad: string, contrato: string, tipo: number, fecha: any, fechaVencimiento: any, adjuntos: any[]) {
        this.titulo = titulo;
        this.descripcion = descripcion;
        this.prioridad = prioridad;
        this.tipo = tipo;
        this.fecha = fecha;
        this.fechaVencimiento = fechaVencimiento;
        this.adjuntos = adjuntos;
    }
}

export class NewIssueComment {
  comentario: string;
  adjuntos: any[];
  fecha: any
  constructor(comentario: string, fecha: any, adjuntos: any[]) {
    this.comentario = comentario;
    this.adjuntos = adjuntos;
    this.fecha = fecha;
  }
}
